export const classes = {
  root: {
    margin: '0 24px 24px 24px',
    justifyContent: 'flex-end',
    padding: 0,
  },
};
